<script>
import Vue from 'vue'
// const tfw_base_url = 'http://wx.jcfwr.com'; //本地
// const zhfc_base_url = 'http://wx.jcfwr.com'; //本地
// const tfw_go_zhfc = 'http://wx.jcfwr.com/h5'; //本地
// const BASE_URL ='http://wx.jcfwr.com/' ;//多层虚拟目录部署
//  const hetong_url = 'http://wx.jcfwr.com/';//合同智杰电脑

//第一步：开发环境打开前3条  手机号码18598853210
// const tfw_base_url = 'http://192.168.10.62:9090' //本地
// const zhfc_base_url = 'http://192.168.10.62:9090' //本地
// const tfw_go_zhfc = 'http://192.168.10.62:9090' //本地
// const tfw_go_zhfc = 'http://192.168.1.105:3000'; //本地

// const zhfc_base_url = ''; //远程
// const tfw_go_zhfc = ''; //远程
// const tfw_base_url = ''; //远程
// const hetong_url = '';//正式智杰电脑
// const BASE_URL ='' ;//多层虚拟目录部署

//第二步：开发环境关闭前3条

const tfw_base_url = 'http://tfw.changshabdc.com/signalr' //长沙二维码
const zhfc_base_url = 'http://tfw.changshabdc.com/' //长沙
const tfw_go_zhfc = 'http://tfw.changshabdc.com/h5' //长沙
const hetong_url = 'http://tfw.changshabdc.com/' //正式智杰电脑
const BASE_URL = 'http://tfw.changshabdc.com/' //多层虚拟目录部署

// /*线上参数*/
const loginRouter = "window.location.replace('http://tfw.changshabdc.com/wechat/login?returnUrl=/h5/index.html$/zhongzhuan')"
// const loginRouter = "window.location.replace('http://172.16.42.222:3000/#/cardList')"
const tokenTime = `let newDate = (new Date()).valueOf();
let oldDate = window.localStorage.getItem('tokenTime');
let expireDate = window.localStorage.getItem('tokenExprires');
if((newDate - oldDate) / 1000 > expireDate*60) {
  window.localStorage.removeItem('token');
}`

//第三步：打开本地参数  去文件constants->index.js
/*本地参数*/
// const loginRouter = ''
// const tokenTime = `let newDate = (new Date()).valueOf();
//   let oldDate = window.localStorage.getItem('tokenTime');
//   let expireDate = window.localStorage.getItem('tokenExprires');
//   if((newDate - oldDate)/1000>7200){
//     window.localStorage.removeItem('token');
//   }`

export default {
  tfw_base_url,
  zhfc_base_url,
  tfw_go_zhfc,
  BASE_URL,
  hetong_url,
  loginRouter,
  tokenTime
}
</script>



// WEBPACK FOOTER //
// src/components/global.vue